import * as PropTypes from 'prop-types';
import * as React from 'react';
import * as I18n from 'i18n-js';
import AlertBox from '@reverbdotcom/commons/dist/components/alert_box';

const ErrorMessage = (props) => {
  const message = props.message || I18n.t('discovery.payoutMethod.defaultErrorMessage');
  const { messageWithLinks } = props;
  const alertColor = props.color;
  const smallAlert = props.small;

  if (messageWithLinks) {
    return (
      <AlertBox color={alertColor} small={!!smallAlert}>
        <p
          className="mb-0"
          dangerouslySetInnerHTML={{ __html: messageWithLinks }}
        />
      </AlertBox>
    );
  }

  return (
    <AlertBox color={alertColor} small={!!smallAlert}>
      <p className="mb-0">
        {message}
      </p>
    </AlertBox>
  );
};

ErrorMessage.propTypes = {
  message: PropTypes.string,
  color: PropTypes.string,
  small: PropTypes.bool,
};

export default ErrorMessage;



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/payout_method_error_message.jsx